module.exports = __webpack_public_path__ + "Bugzz-8e9e27e77ca4ef2b450be2fb2cd21f22.png";